import { useMutation } from '@tanstack/react-query'
import { changeMapRoute } from '../services/mapServices'

export function useMapRouteUpdate() {
  const {
    mutate: mapRouteUpdate,
    isLoading: isLoadingMapRouteUpdate,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: changeMapRoute,
  })

  return {
    mapRouteUpdate,
    isLoadingMapRouteUpdate,
    error,
    isSuccessMapRouteUpdate: isSuccess,
  }
}
